import React, { useEffect, useRef, useState } from 'react';
import { Tab, Nav, Row, Col, Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import createMarkup from 'helpers/createMarkup';
import RatingForm from './RatingForm';
import Reviews from './Reviews';
import SimpleBarReact from 'simplebar-react';

const ProductDetailsFooter = ({ product: { _id, description, specifications, article } }) => {
 const ratingRef = useRef(null);

 const [maxHeight, setMaxHeight] = useState(400);

 const syncHeight = () => {
  if (ratingRef.current) setMaxHeight(ratingRef.current.offsetHeight);
 };

 useEffect(() => {
  syncHeight();

  // Escuchar cambios en el tamaño de la ventana
  window.addEventListener('resize', syncHeight);

  // Usar ResizeObserver para cambios en el contenido
  const observer = new ResizeObserver(syncHeight);
  if (ratingRef.current) observer.observe(ratingRef.current);

  // Limpiar los efectos
  return () => {
   window.removeEventListener('resize', syncHeight);
   if (ratingRef.current) observer.unobserve(ratingRef.current);
  };
 }, []);

 return (
  <div className="mt-4">
   <Tab.Container defaultActiveKey="description">
    <Nav variant="tabs">
     <Nav.Item>
      <Nav.Link eventKey="description" className="ps-0 cursor-pointer outline-none">
       Description
      </Nav.Link>
     </Nav.Item>
     <Nav.Item>
      <Nav.Link eventKey="specifications" className="px-2 px-md-3 cursor-pointer outline-none">
       Specifications
      </Nav.Link>
     </Nav.Item>
     <Nav.Item>
      <Nav.Link eventKey="reviews" className="px-2 px-md-3 cursor-pointer outline-none">
       Reviews
      </Nav.Link>
     </Nav.Item>
    </Nav>
    <Tab.Content>
     <Tab.Pane eventKey="description">
      <div className="mt-3" dangerouslySetInnerHTML={createMarkup(description)} />
     </Tab.Pane>
     <Tab.Pane eventKey="specifications">
      <Table className="fs--1 mt-3">
       <tbody>
        {[
         ...specifications.map((spec, i) => (
          <tr key={i}>
           <td className="bg-100" style={{ width: '30%' }}>
            {spec.label}
           </td>
           <td>{spec.property}</td>
          </tr>
         )),
         ...(article?.specifications.map((spec, i) => (
          <tr key={i}>
           <td className="bg-100" style={{ width: '30%' }}>
            {spec.label}
           </td>
           <td>{spec.property}</td>
          </tr>
         )) ?? [])
        ]}
       </tbody>
      </Table>
     </Tab.Pane>
     <Tab.Pane eventKey="reviews">
      <Row className="mt-3">
       <Col lg={6} className="mb-4 mb-lg-0">
        <SimpleBarReact style={{ maxHeight }} className="pe-2">
         <Reviews product={_id} />
        </SimpleBarReact>
       </Col>
       <Col lg={6} className="ps-lg-5" ref={ratingRef}>
        <RatingForm product={_id} />
       </Col>
      </Row>
     </Tab.Pane>
    </Tab.Content>
   </Tab.Container>
  </div>
 );
};

ProductDetailsFooter.propTypes = {
 product: PropTypes.shape({
  _id: PropTypes.string.isRequired,
  description: PropTypes.string,
  specifications: PropTypes.arrayOf(PropTypes.object),
  article: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
 })
};

export default ProductDetailsFooter;
